(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3666],{

/***/ 75586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23094);

var updateAccordionWithId = // @ts-expect-error - Automatic, Please fix when editing this file
function(param) {
    var id = param.id, openIndices = param.openIndices;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(dispatch) {
        dispatch({
            payload: {
                id: id,
                openIndices: openIndices
            },
            type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .ACCORDION_UPDATE_SELECTION */ .h8
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    updateAccordionWithId: updateAccordionWithId
});


/***/ }),

/***/ 64323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accordion_section; }
});

// UNUSED EXPORTS: AccordionSectionForTest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  @media (min-width: ",
        ") {\n    max-width: 35rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var isTwoColumn = param.isTwoColumn;
    return isTwoColumn && "\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n        gap: 2rem;\n    ";
});
var ColumnWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(props) {
    return props.isTwoColumn && "width: 50%;";
});
var AccordionContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var isTwoColumn = param.isTwoColumn;
    return isTwoColumn && "\n       padding-top: 3rem;\n    ";
});
var SummaryWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});

// EXTERNAL MODULE: ./src/client/actions/accordion/index.ts
var accordion = __webpack_require__(75586);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/components/accordion-image/index.tsx

function accordion_image_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 0;\n  }\n"
    ]);
    accordion_image_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e2b6863-0"
})(accordion_image_templateObject(), function(param) {
    var isTwoColumn = param.isTwoColumn;
    return isTwoColumn && "\n      margin-bottom: 1rem;\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var AccordionImage = function(param) {
    var image = param.image, isTwoColumn = param.isTwoColumn;
    if (!image) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
        isTwoColumn: isTwoColumn,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            src: image.src,
            alt: image.alt
        })
    });
};
/* harmony default export */ var accordion_image = (AccordionImage);

;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/utils/get-visible-accordion-items/index.ts

var getVisibleAccordionItems = function(param) {
    var isOpen = param.isOpen, items = param.items, initialVisible = param.initialVisible;
    if (!initialVisible) {
        return items;
    }
    var visibleItems = (0,fp.slice)(0, initialVisible, items);
    return isOpen ? items : visibleItems;
};
/* harmony default export */ var get_visible_accordion_items = (getVisibleAccordionItems);

// EXTERNAL MODULE: ./src/client/components/sections/accordion-section/styles.module.sass
var styles_module = __webpack_require__(74701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/components/wrap-item-body/index.tsx




// @ts-expect-error - Automatic, Please fix when editing this file
var wrapItemBody = function(body) {
    if (/*#__PURE__*/ react.isValidElement(body)) {
        return body;
    }
    if ((0,fp.isString)(body)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Markdown */.UG, {
            children: body
        });
    }
    if ((0,fp.isPlainObject)(body) || (0,fp.isArray)(body)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
            source: body
        });
    }
    return null;
};
/* harmony default export */ var wrap_item_body = (wrapItemBody);

// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/index.tsx















var AccordionSection = function(param) {
    var actions = param.actions, accordionId = param.accordionId, ariaLabelPrefix = param.ariaLabelPrefix, className = param.className, cta = param.cta, image = param.image, minimalBorder = param.minimalBorder, openIndices = param.openIndices, items = param.items, summary = param.summary, title = param.title, withBorder = param.withBorder, isTwoColumn = param.isTwoColumn, initialVisible = param.initialVisible, spacerSize = param.spacerSize;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    // @ts-expect-error - Automatic, Please fix when editing this file
    var itemsToDisplay = get_visible_accordion_items({
        initialVisible: initialVisible,
        isOpen: isOpen,
        items: items
    });
    // @ts-expect-error - Automatic, Please fix when editing this file
    var showSeeMore = initialVisible && items.length > initialVisible;
    var hasHeaderCopy = title || summary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        spacerSize: spacerSize,
        withBorder: withBorder,
        children: [
            !isTwoColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_image, {
                image: image
            }),
            hasHeaderCopy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                variant: "center",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                        variant: "marginBottomSpacer".concat(summary ? "8" : "6"),
                        children: title
                    }),
                    summary && /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            variant: "marginBottomSpacer8",
                            source: summary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                isTwoColumn: isTwoColumn,
                "data-testid": "content-wrapper",
                children: [
                    isTwoColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnWrapper, {
                        isTwoColumn: isTwoColumn,
                        "data-testid": "two-column-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_image, {
                            image: image,
                            isTwoColumn: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnWrapper, {
                        isTwoColumn: isTwoColumn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionContent, {
                            isTwoColumn: isTwoColumn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Accordion */.UQ, {
                                    className: className,
                                    id: accordionId,
                                    ariaLabelPrefix: ariaLabelPrefix,
                                    items: (0,fp.map)(function(item) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            body: wrap_item_body(item.body)
                                        });
                                    }, itemsToDisplay),
                                    updateSelection: function(newOpenIndices) {
                                        actions.accordion.updateAccordionWithId({
                                            id: accordionId,
                                            openIndices: newOpenIndices
                                        });
                                    },
                                    variant: [
                                        !minimalBorder && "fullBorder",
                                        "white"
                                    ],
                                    openIndices: openIndices
                                }),
                                !isOpen && showSeeMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                                    variant: [
                                        "center",
                                        "marginTopSpacer8"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        icon: {
                                            fontWeight: "regular",
                                            name: "chevron-down",
                                            position: "right"
                                        },
                                        isUnstyled: true,
                                        onClick: function() {
                                            return setIsOpen(true);
                                        },
                                        children: "View more"
                                    })
                                }),
                                (cta === null || cta === void 0 ? void 0 : cta.title) && (cta === null || cta === void 0 ? void 0 : cta.to) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).cta,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        icon: {
                                            fontWeight: "regular",
                                            name: "chevron-right",
                                            position: "right"
                                        },
                                        to: cta.to,
                                        children: cta.title
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
AccordionSection.defaultProps = {
    cta: null,
    image: null,
    initialVisible: null,
    items: [],
    openIndices: [],
    title: "",
    withBorder: false
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapStateToProps = function(state, param) {
    var accordionId = param.accordionId;
    var ref, ref1;
    return {
        openIndices: state === null || state === void 0 ? void 0 : (ref = state.accordion) === null || ref === void 0 ? void 0 : (ref1 = ref.openIndices) === null || ref1 === void 0 ? void 0 : ref1[accordionId]
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            accordion: (0,redux/* bindActionCreators */.DE)(accordion/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var accordion_section = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(AccordionSection));



/***/ }),

/***/ 54996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86268);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _wrapped_section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51878);





var CalloutSection = function(param) {
    var cta = param.cta, image = param.image, summary = param.summary, title = param.title, withBorder = param.withBorder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wrapped_section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        withBorder: withBorder,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .AxisSwitcher */ .e$, {
            reverseColumnPresentationOrder: true,
            limit: 2,
            threshold: "48rem",
            children: [
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .TypeWrapper */ .f3, {
                    variant: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                        src: image.src,
                        alt: image.alt,
                        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().image)
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().content),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.H2, {
                            looksLike: "h3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                                source: title
                            })
                        }),
                        summary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().paragraph),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                                source: summary
                            })
                        }),
                        cta && cta.title && (cta.onClick || cta.to) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            to: cta.to,
                            onClick: cta.onClick,
                            children: cta.title
                        })
                    ]
                })
            ]
        })
    });
};
CalloutSection.defaultProps = {
    cta: null,
    image: null,
    summary: null,
    withBorder: false
};
/* harmony default export */ __webpack_exports__["Z"] = (CalloutSection);


/***/ }),

/***/ 84244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ features_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/features-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  @media (min-width: ",
        ") {\n    max-width: 35rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0.5rem;\n  margin-top: 2rem;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var media = ahm_ui/* theme.media */.rS.media;
var DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-773e8259-0"
})(_templateObject(), media.sm);
var CtaWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-773e8259-1"
})(_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/components/sections/features-section/tile/styles.module.sass
var styles_module = __webpack_require__(92139);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/sections/features-section/tile/cta/index.tsx




var TileCta = function(param) {
    var urlObject = param.urlObject, _isLifeStageSection = param.isLifeStageSection, isLifeStageSection = _isLifeStageSection === void 0 ? false : _isLifeStageSection;
    if (!(urlObject === null || urlObject === void 0 ? void 0 : urlObject.url) || !(urlObject === null || urlObject === void 0 ? void 0 : urlObject.name)) return null;
    return isLifeStageSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
        to: urlObject.url,
        variant: [
            "border",
            "white"
        ],
        className: (styles_module_default()).lifeStageButton,
        children: urlObject.name
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
        to: urlObject.url,
        variant: [
            "marginTopSpacer9"
        ],
        children: urlObject.name
    });
};
/* harmony default export */ var cta = (TileCta);

;// CONCATENATED MODULE: ./src/client/components/sections/features-section/tile/index.tsx








var FeaturesTile = function(param) {
    var image = param.image, summary = param.summary, title = param.title, urlObject = param.urlObject, _withSimpleBit = param.withSimpleBit, withSimpleBit = _withSimpleBit === void 0 ? true : _withSimpleBit;
    var ref;
    var isLifeStageSection = Boolean(urlObject === null || urlObject === void 0 ? void 0 : (ref = urlObject.url) === null || ref === void 0 ? void 0 : ref.startsWith("".concat(ahm_constants/* default.URLS.SALES.REFINE_PRICE */.Z.URLS.SALES.REFINE_PRICE, "?scale=")));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: isLifeStageSection ? (styles_module_default()).lifeStageTileWrapper : (styles_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
            variant: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((0,_define_property/* default */.Z)({}, (styles_module_default()).lifeStageContentWrapper, isLifeStageSection)),
                    children: [
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                            alt: image.alt,
                            src: image.src,
                            className: (styles_module_default()).image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                            looksLike: withSimpleBit ? "h4" : "h6",
                            variant: withSimpleBit ? "simpleBit" : undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                source: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            source: summary
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(cta, {
                    urlObject: urlObject,
                    isLifeStageSection: isLifeStageSection
                })
            ]
        })
    });
};
/* harmony default export */ var features_section_tile = (FeaturesTile);

// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/features-section/index.tsx











var FeaturesSection = function(param) {
    var cta = param.cta, description = param.description, title = param.title, tiles = param.tiles, _withBorder = param.withBorder, withBorder = _withBorder === void 0 ? false : _withBorder, _withSimpleBit = param.withSimpleBit, withSimpleBit = _withSimpleBit === void 0 ? true : _withSimpleBit;
    var numberOfTiles = (0,fp.size)(tiles);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        withBorder: withBorder,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                variant: [
                    "center",
                    "marginBottomSpacer7"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                        variant: (0,fp.compact)([
                            withSimpleBit && "simpleBit"
                        ]),
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            source: description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                lgHorizontalAlign: "center",
                children: (0,uncap_fp_iterator/* default */.Z)(fp.map)(function(tile, index) {
                    var ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: numberOfTiles === 4 ? 3 : 4,
                        md: 12,
                        variant: "marginBottomSpacer10",
                        children: /*#__PURE__*/ (0,react.createElement)(features_section_tile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile), {
                            key: "".concat((0,fp.kebabCase)((ref = (ref1 = tile.image) === null || ref1 === void 0 ? void 0 : ref1.alt) !== null && ref !== void 0 ? ref : ""), "-").concat(index),
                            withSimpleBit: true
                        }))
                    });
                }, tiles)
            }),
            cta && (cta.onClick || cta.to) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: [
                    "marginTopSpacer8",
                    "marginBottomSpacer11"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                        onClick: cta.onClick,
                        to: cta.to,
                        variant: [
                            "border",
                            "white"
                        ],
                        children: cta.title
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var features_section = (FeaturesSection);


/***/ }),

/***/ 74701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","cta":"styles_cta__3jM4X","centeredBlock":"styles_centeredBlock__oAIPA"};

/***/ }),

/***/ 86268:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","paragraph":"styles_paragraph__wxOnf","content":"styles_content__1t3YV","image":"styles_image__tGaV0","wrapper":"styles_wrapper__suzOY"};

/***/ }),

/***/ 92139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","image":"styles_image__Oz7B8","wrapper":"styles_wrapper__MRbsp","lifeStageTileWrapper":"styles_lifeStageTileWrapper__PQS6_","lifeStageContentWrapper":"styles_lifeStageContentWrapper__7Jhpj","lifeStageButton":"styles_lifeStageButton__J7odZ"};

/***/ })

}]);